const storeScrollPosition = () => {
  const scrollY = String(window.pageYOffset || document.documentElement.scrollTop);
  window.localStorage.setItem('prev_scroll_y', scrollY);
};

const clearScrollPosition = () => {
  window.localStorage.removeItem('prev_scroll_y');
};

export default () => {
  document.addEventListener('click', (e) => {
    const target = e.target.closest('a, [data-track-link]');
    if (!target) return;

    if (target.getAttribute('data-store-scroll-position') === 'true') {
      storeScrollPosition();
    } else {
      clearScrollPosition();
    }
  });
};
